import '../styles/styles.css';

import React from 'react';
import { Helmet } from 'react-helmet';

import { impulsaUrl, mainDescription, mainTitle, mainUrl, siteUrl } from '../data/main.data';
import defaultShareImage from '../images/cartaz.jpg';
import favicon from '../images/favicon.jpg';
import defaultLogos from '../images/logos.jpg';
import titleImage from '../images/title.jpg';

const Layout = ({ subtitle, navItems, logos, shareImage, children }) => {
  const logosImage = logos || defaultLogos;
  const shareImageUrl = `${siteUrl}${shareImage || defaultShareImage}`;
  const title = `${mainTitle} - ${mainDescription}${subtitle ? ` | ${subtitle}` : ''}`;

  const footerNavItems = [
    {
      href: "/",
      label: mainTitle.toUpperCase(),
      title: mainDescription,
    },
    {
      href: "/2025",
      label: `${mainTitle.toUpperCase()} 2025`,
      title: `${mainTitle} 2025 - ${mainDescription}`,
    },
    {
      href: "/2026",
      label: `${mainTitle.toUpperCase()} 2026`,
      title: `${mainTitle} 2026 - ${mainDescription}`,
    },
    {
      href: impulsaUrl,
      label: "IMPULSA CINE",
      title: "Impulsa Cine – Encontro de Redes Galegas e Lusófonas de Cinema",
      external: true,
    },
  ];

  const externalProps = (item) =>
    item.external ? { target: "_blank", rel: "noreferrer" } : {};

  return (
    <main id="pontes" lang="gl">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <link rel="canonical" href={mainUrl} />
        <link rel="shortcut icon" href={favicon} />
        <meta name="description" content={mainDescription} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={mainDescription} />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:image" content={shareImageUrl} />
        <meta property="og:image:alt" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="gl_ES" />
        <meta property="og:site_name" content={title} />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={mainDescription} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={shareImageUrl} />
        <meta name="twitter:image:alt" content={title} />
        <meta name="twitter:site" content="@somosabella" />
        <meta name="twitter:creator" content="@somosabella" />
        <script
          defer
          src="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.6.0/js/all.min.js"
        />
      </Helmet>
      <header>
        <h1>
          <a href={mainUrl}>
            <img src={titleImage} alt={title} />
          </a>
        </h1>
        <h3>{mainDescription}</h3>
        {subtitle && <h2>{subtitle}</h2>}
        {navItems && navItems.length > 0 && (
          <nav>
            <ul className="nav">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a href={item.href} title={item.title || item.label} {...externalProps(item)}>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </header>
      {children}
      <footer>
        <div className="logos">
          <img src={logosImage} alt="PONTES" />
        </div>
        <ul className="social">
          <li>
            <a href="https://www.facebook.com/somosabella" aria-label="Facebook">
              <i className="fab fa-facebook-square" title="Facebook" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/somos.abella" aria-label="Instagram">
              <i className="fab fa-instagram-square" title="Instagram" />
            </a>
          </li>
        </ul>
        <h3>{title}</h3>
        <ul className="footer-nav">
          {footerNavItems.map((item) => (
            <li key={item.href}>
              <a href={item.href} title={item.title} {...externalProps(item)}>{item.label}</a>
            </li>
          ))}
        </ul>
      </footer>
      <div className="nav-to-top">
        <a href="#pontes">&#8679; Volver</a>
      </div>
    </main>
  );
};

export default Layout;
